import { Alert, Box } from '@mui/material';
import PageHeader from '@/components/PageHeader/PageHeader';

const UserPage = () => (
  <Box sx={{ width: '100%', maxWidth: 960, mx: 'auto', p: { xs: 2, md: 3 } }}>
    <PageHeader
      eyebrow="Administration"
      title="User details"
      description="Review user access from the organisation user registry."
      compact
    />
    <Alert severity="info">
      User editing is not available on this screen yet. Use the Users registry
      to review current accounts.
    </Alert>
  </Box>
);

export default UserPage;
